 /* eslint-disable */
 import groupService from './setting-groups-service';
 import i18n from '@/lang' // Internationalization
 import teamService from '../../team/team-service';

export default {
  namespaced: true,

  state: {
    loading: false,
    groupList: [],
    teamList: []
  },

  getters: {
    loading: (state) => state.loading,
    teamList: (state) => state.teamList,
    groupList: (state) => state.groupList,
    pager: (state) => state.pager,
  },

  mutations: {
    LOADING(state, payload) {
      state.loading = !!payload;
    },

    TEAM_LIST(state, payload) {
      state.teamList = payload || [];
    },

    GROUP_LIST(state, payload) {
      state.groupList = payload || [];
    },

    CLEAR(state) {
      state.loading = false;
      state.teamList = [];
      state.groupList = [];
    }
  },

  actions: {
    setup({ commit, dispatch, getters }, modelTeam) {
      commit('LOADING', true);
      
        commit('LOADING', false);

        var error = new Error('Equipo no existe.')
        dispatch('shared/error', error, { root: true });
        return Promise.reject(error);
    },

    listTeamsByCategoryId({ commit, dispatch, getters, rootGetters }, categoryId) {
      console.log("LIST TEAMA BY CATEGORY");
      
      commit('TEAM_LIST', []);
      commit('LOADING', true);

      var teamListByCategories = rootGetters['entities/tournament/teamListGroupByCategory']

      commit('TEAM_LIST', teamListByCategories[categoryId]);
      commit('LOADING', false);

      return Promise.resolve(teamListByCategories)
    },

    saveGroup({ getters, commit, rootGetters, dispatch }, model) {
      commit('LOADING', true);

      groupService.saveGroup(model, rootGetters['auth/user'])
      .then(() => {
        dispatch(
          'shared/success',
          `${i18n.t('entities.tournament.group')} ${i18n.t('notification.savedSuccessfully')}`,
          { root: true }
        );
        commit('LOADING', false);
      })
      .catch((error) => {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return Promise.reject(error);
      });
    },

    listGroup({ getters, commit, rootGetters, dispatch }, categoryId) {
      commit('GROUP_LIST', []);
      commit('LOADING', true);
      
      return groupService
        .listGroup(categoryId)
        .then((list) => {
          commit('GROUP_LIST', list);
          commit('LOADING', false);
        })
        .catch((error) => {
          commit('LOADING', false);
          dispatch('shared/error', error, { root: true });
          return Promise.reject(error);
        });
    },

    destroyGroup({ getters, commit, rootGetters, dispatch }, model) {
      commit('LOADING', true);

      return groupService
        .destroyGroup(model, rootGetters['auth/user'])
        .then(() => {
          dispatch(
            'shared/success',
            `${i18n.t('entities.tournament.group')} ${i18n.t('notification.deletedSuccessfully')}`,
            { root: true }
          );
        })
        .catch((error) => {
          commit('LOADING', false);
          dispatch('shared/error', error, { root: true });
          return Promise.reject(error);
        });
    },

    closeGroup({ getters, commit, rootGetters, dispatch }, model) {
      commit('LOADING', true);

      return groupService
        .closeGroup(model, rootGetters['auth/user'])
        .then(() => {
          console.log("<--- GENERATE MATCHES");
          groupService.generateMatches(model, rootGetters['auth/user'])
      
        })
        .then(()=> {
          commit('LOADING', false);
          console.log("<--- GENERATE MATCHES SUCCESS");

          dispatch(
            'shared/success',
            `${i18n.t('entities.tournament.group')} ${i18n.t('notification.savedSuccessfully')}`,
            { root: true }
          );
        })
        .catch((error) => {
          commit('LOADING', false);
          dispatch('shared/error', error, { root: true });
          return Promise.reject(error);
        });
    },

    openGroup({ getters, commit, rootGetters, dispatch }, model) {
      commit('LOADING', true);

      return groupService
        .openGroup(model, rootGetters['auth/user'])
        .then(() => {
          commit('LOADING', false);

          dispatch(
            'shared/success',
            `${i18n.t('entities.tournament.group')} ${i18n.t('notification.savedSuccessfully')}`,
            { root: true }
          );
        })
        .catch((error) => {
          commit('LOADING', false);
          dispatch('shared/error', error, { root: true });
          return Promise.reject(error);
        });
    },

    addTeamGroup({ getters, commit, rootGetters, dispatch }, model) {

      console.log("<--- ADD TEAM");
      if(model.to.groupId != model.from.groupId) {
        commit('LOADING', true);
        
        return groupService
        .addTeam(model, rootGetters['auth/user'])
        .then(() => {
          dispatch(
            'shared/success',
            `${i18n.t('entities.tournament.group')} ${i18n.t('notification.savedSuccessfully')}`,
            { root: true }
          );
          commit('LOADING', false);

        })
        .catch((error) => {
          commit('LOADING', false);
          dispatch('shared/error', error, { root: true });
          return Promise.reject(error);
        });
      } 
    },

    clear({ commit }) {
      commit('CLEAR');
    }
  }
};



// WEBPACK FOOTER //
// ./src/entities/tournament/setting-groups/setting-groups-store.js